export default function Nav() {
  return <nav>Made with 💜 by Israel @ ezysphere | About | Tutorial</nav>;
}
